import React, { useState, useEffect, useMemo, lazy, Suspense } from "react";
import {
  AppBar,
  Box,
  Toolbar,
  IconButton,
  Typography,
  Avatar,
  Menu,
  MenuItem,
  Select,
  CssBaseline,
  Drawer,
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
  styled,
  useTheme,
  CircularProgress,
} from "@mui/material";
import {Menu as MenuIcon,ChevronLeft as ChevronLeftIcon,ChevronRight as ChevronRightIcon,Dashboard as DashboardIcon,Category as CategoryIcon,List as ListIcon,TableRestaurant as TableRestaurantIcon,Person as PersonIcon,PointOfSale as PointOfSaleIcon,Kitchen as KitchenIcon,FileCopy as FileCopyIcon,UnfoldLessDouble as UnfoldLessDoubleIcon,Settings as SettingsIcon,Grading as GradingIcon,} from "@mui/icons-material";
import { Outlet, useNavigate } from "react-router-dom";
//import { useTranslation } from "react-i18next";
import { menuitemlist } from "./MenuItems/Menuitems";
import GroupIcon from '@mui/icons-material/Group';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import BookOnlineIcon from '@mui/icons-material/BookOnline';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';

// Lazy Loading Components
const LazyOutlet = lazy(() =>
  import("react-router-dom").then((mod) => ({ default: mod.Outlet }))
);

// Styles
const drawerWidth = 200;
const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});
const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});
const StyledAppBar = styled(AppBar)(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
  }),
}));
const StyledDrawer = styled(Drawer)(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));
const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));



const menuIcons = [
  <DashboardIcon />,
  <PersonAddIcon />,
   <PointOfSaleIcon />,
  <BookOnlineIcon />,
  <LocalOfferIcon />,
  <GroupIcon />,
  <SettingsIcon />,
 
  <KitchenIcon />,
  <FileCopyIcon />,
  <UnfoldLessDoubleIcon />,  ,
  <GradingIcon />,
];

const MainHomeLayout = () => {
  //const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const theme = useTheme();
  const [activeItem, setActiveItem] = React.useState(menuitemlist()[0][0]);
  const [open, setOpen] = useState(false);
  const [anchorElUser, setAnchorElUser] = useState(null);
  const settings = ["Profile", "Logout"];
  const username = localStorage.getItem("username");

  //const menuItems = useMemo(() => menuitemlist()[0], []);

  const allMenuItems = useMemo(() => menuitemlist(), []);
  const filteredMenuItems = useMemo(() => {
  if (username === "user") {
    // Return only limited menu items for "user"
    const allowedIndices = [0, 1, 2, 4]; // Example: "Dashboard", "Offers"
    return [
      allowedIndices.map((i) => allMenuItems[0][i]),
      allowedIndices.map((i) => allMenuItems[1][i]),
    ];
  }
  // Return full list for admin or others
  return allMenuItems;
}, [username]);

const allowedIndices = [0, 1, 2, 4];
const filteredIcons = username === "user"
  ? allowedIndices.map((i) => menuIcons[i])
  : menuIcons;


  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = "";
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, []);

  const handleDrawerToggle = () => setOpen((prev) => !prev);
  const handleOpenUserMenu = (event) => setAnchorElUser(event.currentTarget);
  const handleCloseUserMenu = (e) => {
    if (e.target.textContent === "Logout") 
      localStorage.clear();
    sessionStorage.clear();
      navigate("/");
    setAnchorElUser(null);
  };
  //   const handleLanguageChange = (event) => {
  //     const language = event.target.value;
  //     i18n.changeLanguage(language).catch((err) => console.error("Language Error:", err));
  //   };

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />

      {/* Top Navigation */}
      <StyledAppBar position="fixed" open={open}>
        <Toolbar>
          <IconButton
            color="inherit"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2 }}
          >
            <MenuIcon />
          </IconButton>

          <Box
            sx={{
              flexGrow: 1,
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
            }}
            onClick={() => navigate("/dashboardpage")}
          >
            Oasis Movies
          </Box>

          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Typography variant="h6" sx={{ mr: 1 }}>
              Welcome
            </Typography>
            <Typography variant="h6" sx={{ color: "#ffe200", mr: 1 }}>
              {username}
            </Typography>

            <Tooltip title="Open settings">
              <IconButton onClick={handleOpenUserMenu}>
                <Avatar alt="User" src="/static/images/avatar/2.jpg" />
              </IconButton>
            </Tooltip>
            <Menu
              
              id="menu-appbar"
              anchorEl={anchorElUser}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {settings.map((setting) => (
                <MenuItem key={setting} onClick={handleCloseUserMenu}>
                  <Typography textAlign="center">{setting}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
        </Toolbar>
      </StyledAppBar>

      {/* Sidebar Navigation */}
      <StyledDrawer variant="permanent" open={open}>
        <DrawerHeader>
          <IconButton onClick={handleDrawerToggle}>
            {theme.direction === "rtl" ? (
              <ChevronRightIcon />
            ) : (
              <ChevronLeftIcon />
            )}
          </IconButton>
        </DrawerHeader>
        <Divider />
        <List>
          {filteredMenuItems[0].map((item, index) => (
            <Tooltip key={index} title="" placement="right">
              <ListItem disablePadding>
                <ListItemButton
                  // onClick={() => navigate(menuitemlist()[1][index])}
                  onClick={() => {
                    setActiveItem(item); // Update active item
                    navigate(filteredMenuItems[1][index]);
                  }}
                  selected={activeItem === item} // Keeps the active state styling
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                    backgroundColor:
                      activeItem === item ? "rgba(0, 0, 0, 0.08)" : "inherit", // Optional: Active background color
                    color: activeItem === item ? "primary.main" : "inherit", // Optional: Change text color
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    {filteredIcons[index]}
                  </ListItemIcon>
                  <ListItemText primary={item} sx={{ opacity: open ? 1 : 0 }} />
                </ListItemButton>
              </ListItem>
            </Tooltip>
          ))}
        </List>
        <Divider />
      </StyledDrawer>

      {/* Page Content */}
      <Box component="main" sx={{ flexGrow: 1, p: 3, overflowX: "hidden" }}>
        <Toolbar />
        <Suspense
          fallback={
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "100vh",
              }}
            >
              <CircularProgress color="primary" />
            </Box>
          }
        >
          <LazyOutlet />
        </Suspense>
      </Box>
    </Box>
  );
};

export default MainHomeLayout;
